"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const formik_1 = require("formik");
const callSlice_1 = require("../../features/call/callSlice");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const styles_1 = __importDefault(require("../../styles/styles"));
const themes_1 = __importDefault(require("../../styles/themes"));
const button_1 = __importDefault(require("../button/button"));
const FieldErrorMessageComponent_1 = __importDefault(require("../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const commentFormstyles_1 = __importDefault(require("./commentFormstyles"));
const eventConstants_1 = require("../../constants/eventConstants");
const CommentForm = ({ action, callRecord }) => {
    const dispatch = useAppDispatch_1.default();
    const initialValues = { comment: callRecord.comment };
    const callDate = new Date(callRecord.calldate);
    const currentDate = new Date();
    const isCurrentDay = callDate.getFullYear() === currentDate.getFullYear() &&
        callDate.getMonth() === currentDate.getMonth() &&
        callDate.getDate() === currentDate.getDate();
    const onSubmit = (values) => {
        dispatch(callSlice_1.commentOnCallDetailRecord({ ...values, id: callRecord.id }));
        action();
    };
    const validate = (values) => {
        const message = 'This field is required.';
        const errors = {};
        if (!values.comment) {
            errors.comment = message;
        }
        return errors;
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: (values) => onSubmit(values), validate: validate }, ({ handleChange, handleSubmit, values }) => (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Comment", onChangeText: handleChange('comment'), value: values.comment, style: [styles_1.default.textInput, styles_1.default.marginTen, commentFormstyles_1.default.input], theme: themes_1.default.textInput, disabled: !isCurrentDay, multiline: true }),
        react_1.default.createElement(formik_1.ErrorMessage, { name: "comment", component: FieldErrorMessageComponent_1.default }),
        react_1.default.createElement(button_1.default, { onPress: handleSubmit, text: "Comment", fill: true, eventName: eventConstants_1.COMMENT_CALL_DETAIL_RECORD, disabled: !isCurrentDay })))));
};
exports.default = CommentForm;
